<template>
    <div>
        <div class="partybuilding_wrapper hidden-xs-only">
            <div class="partybuilding_box common_width">
                <div class="top">
                    <div class="title">党建工作</div>
                    <img src="../../../assets/img/partybuilding.png" alt="" />
                </div>
                <div class="partybuilding-toggle-wrapper">
                    <div class="partybuilding-toggle-bar">
                        <div
                            class="item"
                            v-for="(item, idx) in tabBarList"
                            :key="item.id"
                            v-text="item.text"
                            :class="{ selectstyle: initSelectNum == idx }"
                            @click="tabBarChange(idx)"
                        ></div>
                    </div>
                </div>
                <div class="partybuilding-tab-detail-wrapper clearfix">
                    <div
                        v-show="idx == initSelectNum"
                        class="partybuilding-tab-detail-item"
                        v-for="(item, idx) in partyBuildingList"
                        :key="idx"
                    >
                        <div
                            class="item clearfix"
                            v-for="(innerItem, innerIdx) in item.buildingObj
                                .partyStyleList"
                            :key="innerIdx"
                        >
                            <div class="left fl">
                                <img :src="innerItem.imageUrl" alt="" />
                            </div>
                            <div class="right fl">
                                <h1 class="exceed_one_hidden" style="width:100%" v-text="innerItem.title"></h1>
                                <p
                                    class="exceed_six_hidden"
                                    v-if="innerItem.content"
                                >
                                    {{ formatP(innerItem.content) }}
                                </p>
                                <div
                                    class="read_more"
                                    @click="jumpDetail(innerItem)"
                                >
                                    阅读更多
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <yuu-link :linksList="linkList"></yuu-link>
            </div>
        </div>
        <div class="partybuilding_phone_wrapper hidden-sm-and-up">
            <div class="partybuilding_phone_box">
                <div class="top">
                    <div class="title">党建工作</div>
                    <img src="../../../assets/img/partybuilding.png" alt="" />
                </div>
                <div class="partybuilding-toggle-phone-wrapper">
                    <div class="partybuilding-toggle_phone-bar">
                        <div
                            class="item"
                            v-for="(item, idx) in tabBarList"
                            :key="item.id"
                            v-text="item.text"
                            :class="{ selectstyle: initSelectNum == idx }"
                            @click="tabBarChange(idx)"
                        ></div>
                    </div>
                </div>
                <div class="partybuilding-tab-detail-wrapper clearfix">
                    <div
                        v-show="idx == initSelectNum"
                        class="partybuilding-tab-detail-item"
                        v-for="(item, idx) in partyBuildingList"
                        :key="idx"
                    >
                        <div
                            class="item clearfix"
                            v-for="(innerItem, innerIdx) in item.buildingObj
                                .partyStyleList"
                            :key="innerIdx"
                        >
                            <div class="left fl">
                                <img :src="innerItem.imageUrl" alt="" />
                            </div>
                            <div class="right fl">
                                <h1
                                    class="exceed_one_hidden"
                                    v-text="innerItem.title"
                                ></h1>
                                <p class="exceed_three_hidden">
                                    {{ formatP(innerItem.content) }}
                                </p>
                                <el-button
                                    type="danger"
                                    @click="jumpDetail(innerItem)"
                                    >阅读更多</el-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <yuu-pelink :linksList="linkList"></yuu-pelink>
            </div>
        </div>
    </div>
</template>

<script>
import YuuLink from "../../../components/Links.vue";
import YuuPelink from "../../../components/Phonelinks.vue";
import { cleanGtLtIe, partyStyleIe } from "../../../api/Home/home";
export default {
    components: {
        YuuLink,
        YuuPelink,
    },
    computed: {
        formatP() {
            return (n) => {
                let regVal = n.replace(/<[^>]+>/g, "").replace(/&.*?(?=.;)/g,"").replace(/;/g, "").replace(/[a-zA-Z]/g, "")
                return regVal
            };
        },
    },
    data() {
        return {
            linkList: [
                {
                    text: "人民网",
                    url: "http://www.people.com.cn/",
                },
                {
                    text: "共产党员网",
                    url: "https://www.12371.cn/",
                },
                {
                    text: "中国共产党新闻网",
                    url: "http://cpc.people.com.cn/",
                },
                {
                    text: "学习强国",
                    url: "https://www.xuexi.cn/",
                },
            ],
            initSelectNum: 0,
            tabBarList: [
                {
                    id: 1,
                    text: "党建动态",
                },
                {
                    id: 2,
                    text: "党风廉政",
                },
            ],
            partyBuildingList: [
                {
                    buildingObj: {
                        partyStyleList: [],
                    },
                },
                {
                    buildingObj: {
                        partyStyleList: [],
                    },
                },
            ],
        };
    },
    mounted() {
        this.initPage();
    },
    methods: {
        initPage() {
            this.getCleanGtLtRt();
            this.getPartyStyleRt();
        },
        // 党风廉政
        getCleanGtLtRt() {
            cleanGtLtIe().then((res) => {
                console.log(res);
                this.partyBuildingList[1].buildingObj.partyStyleList = res.rows;
            });
        },
        // 党建动态
        getPartyStyleRt() {
            partyStyleIe().then((res) => {
                console.log(res);
                this.partyBuildingList[0].buildingObj.partyStyleList = res.rows;
            });
        },
        tabBarChange(index) {
            this.initSelectNum = index;
        },
        // 跳转详情
        jumpDetail(item) {
            this.$router.push({
                path: "detail",
                query: {
                    detailObj: item,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/mixin.scss";
// move
.partybuilding_phone_wrapper {
    background-color: #fdf4f3;
    box-sizing: border-box;
    .top {
        position: relative;
        width: px2rem(110);
        height: px2rem(40);
        box-sizing: border-box;
        margin-left: px2rem(20);
        line-height: px2rem(40);
        font-size: px2rem(18);
        color: #da0d02;
        border-bottom: px2rem(3) solid #da0d02;
        margin-bottom: px2rem(20);
        img {
            position: absolute;
            top: px2rem(5);
            right: 0;
            width: px2rem(24);
            height: px2rem(24);
        }
    }
    .partybuilding-toggle-phone-wrapper {
        margin-bottom: 51px;
        .partybuilding-toggle_phone-bar {
            width: px2rem(201);
            height: px2rem(46);
            margin: 0 auto;
            background-color: #f3ebea;
            border-radius: px2rem(24);
            .item {
                float: left;
                width: px2rem(100);
                height: px2rem(46);
                line-height: px2rem(46);
                text-align: center;
                font-size: px2rem(14);
                color: #393939;
                &:nth-child(1) {
                    border-bottom-left-radius: px2rem(24);
                    border-top-left-radius: px2rem(24);
                }
                &:nth-child(2) {
                    border-top-right-radius: px2rem(24);
                    border-bottom-right-radius: px2rem(24);
                }
            }
            .selectstyle {
                background-color: #f9dcda;
                color: #dc1602;
            }
            :hover {
                background-color: #f9dcda;
                color: #dc1602;
            }
        }
    }
    .partybuilding-tab-detail-wrapper {
        .partybuilding-tab-detail-item {
            .item {
                margin-bottom: px2rem(41);
                h1 {
                    font-size: px2rem(14);
                    line-height: px2rem(16);
                    color: #333;
                }
                p {
                    width: px2rem(140);
                    font-size: px2rem(12);
                    line-height: px2rem(20);
                    color: #3d3c3c;
                    margin-top: px2rem(10);
                    margin-bottom: px2rem(15);
                }
                .left {
                    width: 50%;
                    height: px2rem(140);
                    border-radius: px2rem(8);
                    margin-right: px2rem(20);
                    margin-left: px2rem(5);
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .right {
                    width: 40%;
                    .read_more {
                        width: px2rem(130);
                        height: px2rem(40);
                        text-align: center;
                        line-height: px2rem(40);
                        background-color: #dc1602;
                        color: #fefaf9;
                        border-radius: px2rem(24);
                        font-size: px2rem(12);
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
// pc
.partybuilding_wrapper {
    width: 100%;
    padding-top: 43px;
    padding-bottom: 20px;
    box-sizing: border-box;
    background-color: #fdf4f3;
    .partybuilding_box {
        height: 100%;
        .top {
            position: relative;
            width: 140px;
            height: 37px;
            font-size: 24px;
            color: #da0d02;
            border-bottom: 3px solid #da0d02;
            margin-bottom: 18px;
            img {
                position: absolute;
                top: 0;
                right: 0;
                width: 26px;
                height: 26px;
            }
        }
        .partybuilding-toggle-wrapper {
            margin-bottom: 51px;
            .partybuilding-toggle-bar {
                width: 174px;
                height: 46px;
                margin: 0 auto;
                background-color: #f3ebea;
                border-radius: 24px;
                .item {
                    float: left;
                    width: 87px;
                    height: 46px;
                    line-height: 46px;
                    cursor: pointer;
                    text-align: center;
                    font-size: 14px;
                    color: #393939;
                    &:nth-child(1) {
                        border-bottom-left-radius: 24px;
                        border-top-left-radius: 24px;
                    }
                    &:nth-child(2) {
                        border-top-right-radius: 24px;
                        border-bottom-right-radius: 24px;
                    }
                }
                .selectstyle {
                    background-color: #f9dcda;
                    color: #dc1602;
                }
                :hover {
                    background-color: #f9dcda;
                    color: #dc1602;
                }
            }
        }
        .partybuilding-tab-detail-wrapper {
            .partybuilding-tab-detail-item {
                .item {
                    margin-bottom: 41px;
                    h1 {
                        margin-bottom: 29px;
                        font-size: 22px;
                        color: #333;
                    }
                    p {
                        width: 567px;
                        font-size: 14px;
                        line-height: 20px;
                        color: #3d3c3c;
                        margin-top: 27px;
                        margin-bottom: 44px;
                    }
                    .left {
                        width: 321px;
                        height: 170px;
                        border-radius: 8px;
                        margin-right: 29px;
                        img {
                            width: 321px;
                            height: 170px;
                        }
                    }
                    .right {
                        width: 797px;
                        .read_more {
                            width: 130px;
                            height: 40px;
                            text-align: center;
                            line-height: 40px;
                            background-color: #dc1602;
                            color: #fefaf9;
                            border-radius: 24px;
                            font-size: 12px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/components/Partybuilding.vue